var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pic-frame",on:{"click":_vm.skip}},[_c('img',{attrs:{"src":_vm.currentPic,"alt":""}}),_c('img',{staticClass:"hide",staticStyle:{"display":"none"},attrs:{"src":_vm.loadSrc,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }